export const LAB_RESULTS_READINGS_HISTORY_REQUESTED = 'LAB_RESULTS_READINGS_HISTORY_REQUESTED';
export const LAB_RESULTS_READINGS_HISTORY_SUCCEED = 'LAB_RESULTS_READINGS_HISTORY_SUCCEED';
export const LAB_RESULTS_READINGS_HISTORY_FAILED = 'LAB_RESULTS_READINGS_HISTORY_FAILED';

export const LAB_RESULTS_CHART_READINGS_HISTORY_REQUESTED = 'LAB_RESULTS_CHART_READINGS_HISTORY_REQUESTED';
export const LAB_RESULTS_CHART_READINGS_HISTORY_SUCCEED = 'LAB_RESULTS_CHART_READINGS_HISTORY_SUCCEED';
export const LAB_RESULTS_CHART_READINGS_HISTORY_FAILED = 'LAB_RESULTS_CHART_READINGS_HISTORY_FAILED';
